import {
  getProjectDocuments,
  createProjectDocument,
  updateProjectDocument,
  deleteProjectDocument
} from '@/api/workflow';

export default {
  namespaced: true,
  state: () => ({
    documents: {
      loading: false,
      error: null,
      items: [],
      projectId: null
    }
  }),
  mutations: {
    fetchDocumentsPending(state) {
      state.documents.loading = true;
      state.documents.error = null;
      state.documents.items = [];
      state.documents.projectId = null;
    },
    fetchDocumentsSuccess(state, { documents, projectId }) {
      state.documents.loading = false;
      state.documents.error = null;
      state.documents.items = documents;
      state.documents.projectId = projectId;
    },
    fetchDocumentsFailure(state, error) {
      state.documents.loading = false;
      state.documents.error = error;
    },
    setDocumentsError(state, error) {
      state.documents.error = error;
    },
    addDocument(state, document) {
      state.documents.items = [...state.documents.items, document];
    },
    setDocument(state, document) {
      state.documents.items = state.documents.items.map(item => {
        if (item.id === document.id) {
          return document;
        }
        return item;
      });
    },
    removeDocument(state, document) {
      state.documents.items = state.documents.items.filter(item => item.id !== document.id);
    }
  },
  actions: {
    async fetchCurrentProjectDocuments({ commit, state, rootState }) {
      if (state.documents.projectId === rootState.workflow.currentProjectId) {
        return;
      }
      commit('fetchDocumentsPending');
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId
        };
        const documents = await getProjectDocuments(payload);
        commit('fetchDocumentsSuccess', { documents, projectId: payload.projectId });
      } catch (err) {
        console.error('Server error when getting documents', err);
        commit('fetchDocumentsFailure', 'Error when getting documents');
      }
    },
    async addCurrentProjectDocument({ commit, rootState }, { document }) {
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          ...document,
          fileId: document.resumableFile.uniqueIdentifier,
          userIds: document.users.map(u => u.id)
        };
        const result = await createProjectDocument(payload);
        commit('addDocument', result);
      } catch (err) {
        console.error(`Server error when adding document`, err);
        throw err;
      }
    },
    async updateCurrentProjectDocument({ commit, state, rootState }, { document }) {
      const previousValue = state.documents.items.find(item => item.id === document.id);
      commit('setDocument', document);
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          documentId: document.id,
          ...document
        };
        await updateProjectDocument(payload);
      } catch (err) {
        console.error(`Server error when updating document`, err);
        commit('setDocument', previousValue);
        commit('setDocumentsError', 'Error when updating document');
      }
    },
    async updateCurrentProjectDocumentUsers({ commit, state, rootState }, { document }) {
      const previousValue = state.documents.items.find(item => item.id === document.id);
      commit('setDocument', document);
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          documentId: document.id,
          userIds: document.users.map(u => u.id)
        };
        await updateProjectDocument(payload);
      } catch (err) {
        console.error(`Server error when updating document users`, err);
        commit('setDocument', previousValue);
        commit('setDocumentsError', 'Error when updating document');
      }
    },
    async removeCurrentProjectDocument({ commit, rootState }, { document }) {
      commit('removeDocument', document);
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          documentId: document.id
        };
        await deleteProjectDocument(payload);
      } catch (err) {
        console.error(`Server error when removing document`, err);
        commit('setDocumentsError', 'Error when removing document');
      }
    }
  }
};
